import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HelpConstant } from '../help/help.constant';
import { IHelp } from 'src/app/common/model/support.model';

@Component({
  selector: 'app-help-details',
  templateUrl: './help-details.component.html',
  styleUrls: ['./help-details.component.scss']
})
export class HelpDetailsComponent implements OnInit {
  helpDetails!: IHelp | undefined;
  helpItems: IHelp[] = HelpConstant;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.getHelpDetailsIdFromParam();
  }

  getHelpDetailsIdFromParam(): void {
    this.activatedRoute.params.subscribe({
      next: (params) => {
        const helpDetailsId = params['helpId'];
        if (helpDetailsId) {
          this.helpDetails = this.helpItems.find((x) => x._id === helpDetailsId);
        }
      }
    });
  }
}
